import { Input, InputLabel, TextField } from '@material-ui/core'
import apiServices, {axiosInstance} from '../../../services/apiServices'
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { FormControl, FormHelperText } from '@mui/material'
import SideBarHeader from '../../../SideNavBar/SideBarHeader';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import InputField from '../../../Shared/InputField';
import Button from '../../../Shared/Button/Button';
import { GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

function ContactUs(){
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory()
  const dispatch = useDispatch();
  const loginUserSchema = Yup.object().shape({
      email: Yup.string()
      .email("Please enter valid email address")
      .required("Please enter email address"),
      message: Yup.string()
      .required("Please enter Message"),     
      firstName: Yup.string()
      .required("Please enter firstName"),     
      lastName: Yup.string()
      .required("Please enter LastName") 
  });
  const handleToken = (token) => {
    // setIsLoading(true);
    // setIsLoading(false);
    // console.log("Token>>>",token);
    return token;
  };
  const formik = useFormik({
    initialValues: {
      email: "",
      message: "",
      firstName: "",
      lastName: "",
      recaptchaToken:"",
      platform:"buzzcom",
    },
    enableReinitialize: true,
    validationSchema: loginUserSchema,
    onSubmit: async (values) => {
      console.log("submitting>>>")
      try{
      setIsLoading(true);
      const recaptchaToken = await executeRecaptcha('submit');
    console.log("Token>>>",recaptchaToken);
      values.recaptchaToken = recaptchaToken
      const response = await apiServices.contactUs(values);
      if (response && response.error) {
        throw new Error(response.error.message);
      }
      if (response && response.error) {
        throw new Error(response.error.message);
      }
        alert('Message Sent!')
    }catch(err){
      alert(`Error: ${err.message}`);
    }finally{
      setIsLoading(false);
    }
    },
  });


  return (
        <div className='' >
          <SideBarHeader />
          {/* {<GoogleReCaptcha onVerify={handleToken} />} */}
          <div className="row">
        <div className="col-sm-3">
          <div className="col-sm-12 p-5">
            <Link to="/buzzcom" className="link_decoration">
              {" "}
              <button className="btn btn-light btn-lg rounded-circle pt-2 pb-2 button_style_forget">
                <span className="right_arrow_login1 ">
                  <i className="fas fa-arrow-left"></i>
                </span>
              </button>{" "}
            </Link>
          </div>
        </div>
        <div className="col-sm-6  border-scss">
          <FormikProvider value={formik}>
            <Form noValidate onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-sm-1"></div>
                <div className="col-sm-10">
                  <div className="col-sm-12 px-4 text-center pt-5">
                    <h1 className="heading4_login m-0">
                      Contact Us
                    </h1>
                  </div>

                  <div className="col-sm-12 px-4 pt-4">
                    <label className="label_login m-0">Email</label>
                    <InputField
                      type="text"
                      placeholder="example@hotmail.com"
                      name="email"
                      value={formik.values && formik.values.email}
                      onHandleChange={formik.handleChange}
                      error={Boolean(
                        formik.touched.email && formik.errors.email
                      )}
                      helpertext={formik.errors.email}
                    />
                    <label className="label_login m-0">Message</label>
                    <InputField
                      type="text"
                      placeholder="Message"
                      name="message"
                      value={formik.values && formik.values.message}
                      onHandleChange={formik.handleChange}
                      error={Boolean(
                        formik.touched.email && formik.errors.email
                      )}
                      helpertext={formik.errors.email}
                    />
                    <label className="label_login m-0">First Name</label>
                    <InputField
                      type="text"
                      placeholder="Sam"
                      name="firstName"
                      value={formik.values && formik.values.firstName}
                      onHandleChange={formik.handleChange}
                      error={Boolean(
                        formik.touched.firstName && formik.errors.firstName
                      )}
                      helpertext={formik.errors.email}
                    />
                    <label className="label_login m-0">Last Name</label>
                    <InputField
                      type="text"
                      placeholder="Joe"
                      name="lastName"
                      value={formik.values && formik.values.lastName}
                      onHandleChange={formik.handleChange}
                      error={Boolean(
                        formik.touched.lastName && formik.errors.lastName
                      )}
                      helpertext={formik.errors.email}
                    />
                    {/* <div className="g-recaptcha" data-sitekey={process.env.RecaptchaSiteKey}></div> */}
                  </div>

                  <div className="col-sm-12 px-4">
                    <Button
                      size={"sm"}
                      className=" button_style_login my-4"
                      variant="outline"
                      isLoading={isLoading}
                      onHandleClick={formik.handleSubmit}
                    >
                      Send Message{" "}
                    </Button>
                  </div>
                </div>
                <div className="col-sm-1"></div>
              </div>
            </Form>
          </FormikProvider>
        </div>
        <div className="col-sm-3  ">
          <div className="row">
            <div className="col-sm-1"></div>
            <div className="col-sm-10"></div>
            <div className="col-sm-1"></div>
          </div>
        </div>
        </div>
        </div>
    )
}

export default ContactUs;